class PrepareUpcomingShippingInformationWorkflow {
    constructor($http, SweetAlert) {
        this.api = $http;
        this.sweetAlert = SweetAlert;
        this.key = 'prepare-upcoming-shipping-information';
        this.title = 'Prepare shipping information';
        this.level = 'selected';
    }

    action({}, store) {
        this.api.post('contacts/prepare-shipping-for-upcoming', {
            contacts: store.getters.selectedFilters,
        }).then(() => {
            this.sweetAlert.success('Job scheduled', 'The job to prepare the shipping addresses was scheduled');
        }, () => {
            this.sweetAlert.error('Error', 'The job to prepare the shipping addresses was scheduled');
        })
    }
}

/**
 * @ngdoc service
 * @name contacts.factories:createBillingDocuments
 *
 * @description
 *
 */
angular
    .module('festzelt-os.contacts')
    .factory('prepareUpcomingShippingInformation', [
        '$http',
        'SweetAlert',
        ($http, SweetAlert) => new PrepareUpcomingShippingInformationWorkflow($http, SweetAlert)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/list-view/prepare-upcoming-shipping-information.js